import { render, staticRenderFns } from "./ConsultaProdutosList.vue?vue&type=template&id=264273ba"
import script from "./ConsultaProdutosList.vue?vue&type=script&lang=js"
export * from "./ConsultaProdutosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports